// extracted by mini-css-extract-plugin
export default {"heading":"style_heading__7ipF+","sign_sec":"style_sign_sec__SOdpj","sign_hero_wrap":"style_sign_hero_wrap__70iGc","cont_form_wrap":"style_cont_form_wrap__A+DAN"};